var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockStop2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1280,
    height: 1280,
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ea4d36",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.125,0) scale(0.125,0.125)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(418,618)",
    d: "M0,0h20l11,3l14,7l11,9l9,12l5,11l3,11v22l-4,13l-7,13l-12,16l-20,30l-15,25l-16,29l-8,17l-7,14l-13,31l-13,36l-10,33l-7,28l-7,34l-5,35l-3,27l-2,40v32l2,39l4,38l6,36l6,29l9,34l13,40l11,28l13,30l18,36l14,24l11,18l8,12l13,19l10,13l11,14l8,10l12,14l12,13l9,10l25,25l8,7l12,11l11,9l12,10l13,10l18,13l16,11l22,14l28,16l27,14l32,15l36,14l36,12l34,9l31,7l37,6l36,4l32,2l29,1l14,2l12,5l11,7l11,11l8,14l4,12l1,6v14l-2,10l-5,13l-10,14l-9,8l-12,7l-13,4l-6,1h-33l-49,-3l-42,-5l-36,-6l-37,-8l-34,-9l-29,-9l-32,-11l-32,-13l-27,-12l-19,-9l-19,-10l-27,-15l-23,-14l-30,-20l-18,-13l-16,-12l-16,-13l-11,-9l-10,-9l-8,-7l-10,-9l-15,-14l-26,-26l-7,-8l-12,-13l-9,-11l-12,-14l-20,-26l-12,-17l-10,-14l-12,-19l-13,-21l-14,-25l-10,-19l-8,-16l-10,-21l-13,-31l-11,-29l-12,-37l-10,-36l-8,-36l-7,-39l-5,-40l-3,-38l-1,-28v-37l2,-39l3,-33l6,-42l7,-37l8,-33l8,-29l12,-37l13,-34l13,-30l14,-29l15,-29l14,-24l13,-21l17,-25l10,-14l12,-16l10,-9l16,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(1000,320)",
    d: "M0,0h46l38,2l33,3l37,5l38,7l38,9l44,13l29,10l40,16l35,16l35,18l24,14l24,15l18,12l20,14l21,16l14,11l14,12l11,9l31,29l20,20l7,8l8,8l9,11l11,12l11,14l12,15l13,18l12,17l12,18l13,21l14,24l12,23l11,21l14,31l15,38l14,41l11,40l8,34l7,40l5,37l3,35l1,16v49l-4,13l-6,11l-8,10l-10,8l-14,7l-11,3l-11,1l-16,-2l-16,-7l-13,-10l-10,-13l-5,-11l-3,-12l-1,-13l-1,-30l-3,-39l-5,-38l-7,-36l-8,-33l-11,-36l-9,-26l-14,-34l-16,-33l-10,-20l-10,-17l-11,-18l-13,-20l-20,-28l-11,-14l-11,-13l-9,-11l-12,-13l-11,-12l-26,-26l-8,-7l-15,-13l-17,-14l-16,-12l-18,-13l-24,-16l-21,-13l-27,-15l-32,-16l-30,-13l-35,-13l-28,-9l-34,-9l-33,-7l-31,-5l-37,-4l-32,-2h-59l-40,3l-37,5l-37,7l-35,9l-27,8l-37,13l-31,13l-30,14l-14,6l-15,3l-16,-1l-14,-4l-11,-6l-10,-9l-7,-8l-7,-14l-3,-10l-1,-16l3,-15l5,-12l7,-11l8,-8l13,-8l26,-13l25,-11l25,-10l30,-11l28,-9l32,-9l39,-9l38,-7l40,-5l37,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(1225,1364)",
    d: "M0,0h534l1,1v514l-5,1h-530l-1,-1v-514zM95,92v328h348v-328z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(757,107)",
    d: "M0,0h534l14,4l12,7l12,11l9,14l5,14l1,6v14l-3,14l-8,16l-11,12l-8,6l-10,5l-14,4l-32,1h-478l-24,-1l-15,-5l-10,-6l-10,-9l-6,-7l-5,-8l-4,-10l-2,-9v-19l3,-12l7,-14l10,-12l11,-8l13,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(1013,619)",
    d: "M0,0h22l14,4l12,7l12,11l9,14l4,10l2,14v429l-1,14l-5,15l-7,11l-8,9l-13,9l-13,5l-10,2h-16l-15,-4l-13,-7l-12,-11l-7,-10l-5,-11l-3,-14v-442l4,-16l6,-11l10,-12l11,-8l13,-6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockStop2);
export default __webpack_public_path__ + "static/media/clock-stop2.e2d863a66359bbb82549c8b7fe7e42f6.svg";
export { ForwardRef as ReactComponent };